
import { IGetAllSubscriptionsItem, SubscriptionSerivce } from "@/services/subscription-service";
import { toDateString } from "@/utils/strings";
import { tierToString } from "@/utils/tier";
import { IDataTableColumn, ISelectItem } from "winfakt-vue-components/src/classes";
import Vue from "vue";
import { AuthService } from "@/services/auth-service";
import AppFetchingSpinnerOverlay from "@/components/FetchingSpinnerOverlay.vue";

type StatusFilter = "all" | "active" | "canceled";

export default Vue.extend({
	data(){
		return {
			items: [] as IGetAllSubscriptionsItem[],
			count: 0,
			isFetching: false,
			limit: 100,
			selectedItems: [] as IGetAllSubscriptionsItem[],
			filter: "all" as StatusFilter
		};
	},
	computed: {
		offset():string{
			if (this.items.length == 0){
				return "";
			}
			return this.items[this.items.length-1].id;
		},
		editDisabled():boolean{
			return this.editLink == "";
		},
		// eslint-disable-next-line max-lines-per-function
		columns():IDataTableColumn[]{
			return [
				{
					name: "ID",
					property: "id",
					width: "100px",
					disableSorting: true
				},
				{
					name: "Company",
					property: "company.name",
					width: "200px",
					disableSorting: true
				},
				{
					name: "Company ID",
					property: "company.id",
					width: "100px",
					disableSorting: true
				},
				{
					name: "Volgende betaal dag",
					property: "nextPayDate",
					width: "150px",
					disableSorting: true,
					print(date:null | Date):string{
						if (!date) return "Geen";
						return toDateString(date);
					}
				},
				{
					name: "Prijs",
					property: "amount",
					width: "100px",
					right: true,
					disableSorting: true

				},
				{
					name: "Status",
					property: "status",
					width: "150px",
					disableSorting: true
				},
				{
					name: "Tier",
					property: "tier",
					print: tierToString,
					disableSorting: true
				}
			];
		},
		editLink():string{
			if (this.selectedItems.length == 0) return "";
			if (!this.selectedItems[0].company) return "";
			return `/companies/${this.selectedItems[0].company.id}/edit`;
		},
		infoLink():string{
			if (this.selectedItems.length == 0) return "";
			if (!this.selectedItems[0].company) return "";
			return `/companies/${this.selectedItems[0].company.id}/info`;
		},
		statusFilterItems():ISelectItem<StatusFilter>[]{
			return [
				{
					text: "Alle abonnementen",
					value: "all"
				},
				{
					text: "Actief",
					value: "active"
				},
				{
					text: "Geanuleerd",
					value: "canceled"
				}
			];
		},
		filteredItems():IGetAllSubscriptionsItem[] {
			if (this.filter == "canceled") {
				return this.items.filter(i=>i.status == "canceled");
			}
			if (this.filter == "active"){
				return this.items.filter(i=>i.status == "active");
			}
			return this.items;
		}
	},
	methods: {
		async fetch(){
			if (this.isFetching) return;
			this.isFetching = true;
			try{
				let result = await SubscriptionSerivce.getAllSubscriptions(this.limit, this.offset);
				this.items.push(...result.items);
				for (let i = this.items.length-1; i >= 0; i--){
					let foundIndex = this.items.findIndex(item => item.id == this.items[i].id);
					if (foundIndex != i){
						this.items.splice(i, 1);
					}
				}
				this.count = result.count;
			}catch(err){

			}
			this.isFetching = false;
		},
		onScroll(scroll:Event){
			let target = scroll.target as HTMLElement;
			let lastChild = target.lastElementChild as HTMLElement;
			if (!lastChild) {
				this.fetch();
				return;
			}
			if (lastChild.offsetTop < target.scrollTop + target.clientHeight + 50) {
				this.fetch();
				return;
			}
		},
		hasPermission(permission:string):boolean{
			if (!AuthService.user){
				return false;
			}
			return AuthService.user.hasPermission(permission);
		}
	},
	mounted(){
		this.fetch();
	},
	components: {
		AppFetchingSpinnerOverlay
	}
});
